import { useIndexPrice } from "./indexprice";

export function useLastPrice(ep_id: number) {
  const { data, mutate, getPrice } = useIndexPrice(ep_id);

  return {
    data,
    mutate,
    getPrice,
  };
}
